export type ResponseCode  = 1 | 2 | 3 | 4;
export type AlertCategory = 'lockdown' | 'fire' | 'police' | 'medical' | 'administrative';

export const RESPONSE_LABELS: Record<ResponseCode, string> = {
  1: 'Secure / Ok',
  2: 'Need Help',
  3: 'Need Medical',
  4: 'In Danger'
};

// Mirrors alert_types table (id 1–10)
export const ALERT_TYPES: Record<number, string> = {
  1: 'Medical',
  2: 'Fire',
  3: 'Police',
  4: 'Lockdown',
  5: 'Administrative',
  6: 'Test Medical',
  7: 'Test Fire',
  8: 'Test Police',
  9: 'Test Administrative',
  10: 'Test Lockdown'
};

export const RECEIVER_TYPE_LABELS: Record<number, string> = {
  1: 'User',
  2: 'User Group',
  3: 'Building',
  4: 'Message Group',
  5: 'App Admins',
  6: 'App Users',
  7: 'All Users'
};

// Groups alert_type_id into calendar/chart display categories.
// Test variants (6–10) roll up to their base category.
export const ALERT_CATEGORY_MAP: Record<number, AlertCategory> = {
  1: 'medical',        6: 'medical',
  2: 'fire',           7: 'fire',
  3: 'police',         8: 'police',
  4: 'lockdown',       10: 'lockdown',
  5: 'administrative', 9: 'administrative'
};
